<!--
    描述：法律法规 主页面
    时间：2020-10-28
    Created by ws
-->
<template>
	<div class="h100 audit">
		<filter-layout @search="doSearch" @reset="doRefresh">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchForm" label-width="120px" :model="searchObj">
					<el-form-item label="文件名称：" prop="sname">
						<el-input v-model="searchObj.sname" placeholder="请输入" size="small" clearable></el-input>
					</el-form-item>
					<el-form-item label="有效截止时间：" prop="abortDate">
						<el-date-picker
							v-model="searchObj.abortDate"
							type="date"
							placeholder="请选择时间"
							size="small"
							value-format="yyyy-MM-dd"
							:clearable="false"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="发布时间：" prop="dateArr" class="date-width">
						<el-date-picker
							v-model="searchObj.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
							:picker-options="endDatePicker"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="发布人：" prop="publisher">
						<el-input v-model="searchObj.publisher" placeholder="请输入" size="small" clearable></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<div class="content-header">
					<div class="title">
						合计法律法规：<span class="blue">{{ totalResult }}</span> 条
					</div>
					<div class="btnGroups">
						<el-button v-if="roleBtns.includes('lawAndrules-add')" class="btn-success" size="small" @click="doAdd">新增</el-button>
						<el-input
							size="small"
							class="input-width hidden"
							v-model="searchObj.sname"
							@keyup.enter.native="doSearch('1')"
							placeholder="请输入相关文件名称..."
						>
							<template slot="append">
								<el-button size="small" icon="el-icon-search" class="btn-append" @click="doSearch('1')"></el-button>
							</template>
						</el-input>
						<!-- <el-button
              type="primary"
              class="btn-blue ml10"
              size="small"
              @click="searchToggle = !searchToggle"
            >
              筛选
              <i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
              <i v-else class="el-icon-caret-top ml5"></i>
            </el-button> -->
						<el-button size="small" class="btn-blue ml10" icon="el-icon-refresh" type="primary" @click="doRefresh"></el-button>
					</div>
				</div>
				<!-- 表格内容 -->
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table
							:data="tableData"
							border
							resizable
							height="100%"
							size="small"
							highlight-current-row
							highlight-hover-row
							:loading="loading"
							show-overflow="tooltip"
							show-header-overflow="tooltip"
						>
							<vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
							<vxe-table-column field="sname" title="文件名称" show-overflow min-width="180" header-align="center"></vxe-table-column>
							<vxe-table-column field="applySysName" title="应用业务" min-width="150" header-align="center"></vxe-table-column>
							<vxe-table-column
								field="applyRoleName"
								title="应用对象"
								show-overflow
								min-width="180"
								header-align="center"
							></vxe-table-column>
							<vxe-table-column field="abortTime" title="有效截止时间" min-width="150" align="center"></vxe-table-column>
							<vxe-table-column field="publisher" title="发布人" min-width="150" align="center"></vxe-table-column>
							<vxe-table-column field="createDate" title="发布时间" sortable="" min-width="150" align="center"></vxe-table-column>
							<vxe-table-column title="状态" width="100" align="center">
								<template v-slot="{ row }">
									<vxe-switch
										:value="row.isFlag"
										open-label="启用"
										close-label="禁用"
										:open-value="1"
										:close-value="0"
										:class="{
											opacityHide: !roleBtns.includes('lawAndrules-enable')
										}"
										@click.native.prevent="handleSwitch(row)"
									></vxe-switch>
								</template>
							</vxe-table-column>
							<vxe-table-column title="操作" min-width="160" align="center">
								<template v-slot="{ row }">
									<el-button
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										v-if="roleBtns.includes('lawAndrules-edit')"
										@click="doEdit(row)"
									>
										<svg-icon icon-class="form-edit"></svg-icon> 编辑
									</el-button>
									<el-button
										type="danger"
										size="small"
										round
										plain
										class="table-btn"
										icon="el-icon-delete"
										v-if="roleBtns.includes('lawAndrules-del')"
										@click="doDelete(row)"
										>删除
									</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<vxe-pager
							size="mini"
							:current-page="currentPage"
							:page-size="pageSize"
							:total="totalResult"
							class="text-center"
							:page-sizes="[10, 20, 50, 100, { label: '全部数据', value: -1 }]"
							:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
							@page-change="handlePageChange"
						>
						</vxe-pager>
					</div>
				</div>
			</template>
		</filter-layout>
		<!-- 新增弹窗 -->
		<el-dialog
			:title="dialogObj.title"
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:fullscreen="true"
			:close-on-click-modal="false"
			custom-class="h100-dialog"
			@closed="handleClosed"
			center
		>
			<el-form :model="ruleForm" ref="ruleForm" v-if="dialogObj.visible" :rules="formRules" label-width="120px">
				<el-form-item label="文件名称" prop="sname">
					<el-input v-model="ruleForm.sname"></el-input>
				</el-form-item>
				<el-form-item label="应用业务" prop="applySysList">
					<el-select v-model="ruleForm.applySysList" @remove-tag="roleChange" multiple>
						<el-option v-for="(item, index) in rangeList" :key="'业务' + index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用对象" prop="applyRoleList">
					<el-select v-model="ruleForm.applyRoleList" multiple>
						<el-option-group v-for="group in filterRange" :key="group.label" :label="group.label">
							<el-option v-for="item in group.children" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item label="有效截至时间" prop="abortDate">
					<el-date-picker
						v-model="ruleForm.abortDate"
						type="date"
						placeholder="请选择截止时间"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						:clearable="false"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="内容" prop="content">
					<wang-editor v-model="ruleForm.content" ref="wangEditor" height="100%"></wang-editor>
				</el-form-item>
				<el-form-item label="附件">
					<public-upload ref="upload" tableName="operate_sys_rule" assortment="law_upload" :aid="ruleForm.id" :needRefresh="false"></public-upload>
				</el-form-item>
			</el-form>

			<!-- footer 组件 -->
			<div slot="footer" class="pdb10 text-center">
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
				<el-button type="primary" size="small" class="btn btn-blue" @click="doSubmit">确 定 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { deleteRule, getRange, getRules, saveRules, setFlag } from '@/api/modules/rulesManagement'
import { mapState } from 'vuex'

export default {
	data() {
		return {
			treeProps: {
				label: 'sname'
			},
			searchToggle: true,
			splitV: 0.2,
			tableData: [],
			currentPage: 1,
			pageSize: 10,
			totalResult: 0,
			loading: false,
			searchObj: {
				// curRuleType: '',
				sname: '',
				abortDate: '',
				startDate: '', // 开始时间
				endDate: '', // 结束时间
				publisher: '' //  发布人
			},
			dialogObj: {
				title: '新增',
				visible: false,
				width: '850px',
				mode: 'add'
			},
			ruleForm: {
				disabled: false,
				sname: '', // 名称
				type: '', // 类型
				applyRole: '', // 应用对象
				applyRoleList: [], // 应用对象数组
				applySys: '', // 应用业务
				applySysList: [], // 应用业务数组
				content: '', // 内容
				abortDate: '' //截止有效时间
			},
			formRules: {
				sname: [
					{ required: true, message: '名称不能为空' },
					{
						pattern: /^[\u4E00-\u9FA5]+$/,
						message: '请输入中文！',
						trigger: 'blur'
					}
				],
				applyRoleList: [
					{
						required: true,
						type: 'array',
						message: '请选择应用对象！',
						trigger: 'change'
					}
				],
				applySysList: [
					{
						required: true,
						type: 'array',
						message: '请选择应用业务！',
						trigger: 'change'
					}
				],
				abortDate: [
					{
						required: true,
						message: '请选择有效截至时间！',
						trigger: 'blur'
					}
				],
				content: [
					{
						required: true,
						message: '请输入内容！',
						trigger: 'blur'
					}
				]
			},
			rangeList: [], // 应用范围
			startDatePicker: this.beginDate(),
			endDatePicker: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				}
			}
		}
	},
	created() {
		this.doSearch()
		this.getRangeList()
	},
	methods: {
		roleChange(val) {
			console.log(666)
			this.rangeList.find((y) => {
				if (y.value === val) {
					let arr = y.children
					arr.map((x) => {
						let item = this.ruleForm.applyRoleList.findIndex((z) => z === x.value)
						if (item > -1) {
							this.ruleForm.applyRoleList.splice(item, 1)
						}
					})
				}
			})
		},
		// 左侧协议制度树 节点点击
		handleNodeClick(data, node) {
			this.searchObj.curRuleType = data.value
			this.ruleForm.type = data.value
			this.ruleForm.disabled = data.value === '' ? false : true
			this.doSearch()
		},

		// 点击切换状态
		handleSwitch(row) {
			if (this.roleBtns.includes('lawAndrules-enable')) {
				let _flag = row.isFlag == 0 ? 1 : 0
				this.$confirm('此操作将改变当前法规的状态, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						setFlag({ id: row.id, isFlag: _flag })
							.then((res) => {
								if (res.code === 0) {
									this.$message.success(res.msg)
									row.isFlag = _flag
								}
							})
							.catch((err) => {})
					})
					.catch(() => {
						this.$message.info('已取消操作！')
					})
			} else {
				this.$message.warning('当前账号没权限进行此操作！')
			}
		},

		// 点击新增
		doAdd() {
			this.dialogObj.title = '新增法律法规'
			this.dialogObj.mode = 'add'
			this.dialogObj.visible = true
			this.ruleForm.id = this.$SnowFlake.nextId()
		},

		// 点击编辑
		doEdit(row) {
			let obj = Object.assign({}, row)
			obj.applyRoleList = obj.applyRole.split(',')
			obj.applySysList = obj.applySys.split(',')
			this.dialogObj.title = '编辑'
			this.dialogObj.visible = true
			this.dialogObj.mode = 'edit'
			this.ruleForm = obj
			// 触发applySysList 清空事件了 ，roleList 没了
			setTimeout(() => {
				this.ruleForm.applyRoleList = this.ruleForm.applyRole.split(',')
			}, 500)
		},

		// 点击删除
		doDelete(row) {
			if (row.isFlag == 1) {
				this.$message.error('启用的协议无法删除')
			} else {
				this.$confirm('确认删除该协议制度吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						deleteRule({ id: row.id })
							.then((res) => {
								this.$message.success('删除成功！')
								this.doRefresh()
							})
							.catch((err) => {})
					})
					.catch(() => {})
			}
		},

		// 确认添加/编辑
		doSubmit() {
			let params = Object.assign({}, this.ruleForm)
			params.applyRole = params.applyRoleList.join(',')
			params.applySys = params.applySysList.join(',')
			params.type = '1001016002'
			params.newFlag = this.dialogObj.mode == 'add' ? 0 : 1
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					saveRules(params)
						.then((res) => {
							this.$message.success(res.msg)
							this.dialogObj.visible = false
						})
						.catch((err) => {})
				} else {
					this.$message.warning('请填写必填项')
				}
			})
		},

		// 切换页码
		handlePageChange({ currentPage, pageSize }) {
			this.currentPage = currentPage
			this.pageSize = pageSize
			this.doSearch()
		},

		// 获取应用
		getRangeList() {
			getRange({})
				.then((res) => {
					this.rangeList = res.data
				})
				.catch((err) => {})
		},

		// 查询获得规则
		doSearch(type) {
			if (type && type == '1') {
				this.currentPage = 1
				this.pageSize = 10
			}
			this.tableData = []
			this.loading = true
			if (this.searchObj.dateArr && this.searchObj.dateArr.length > 0) {
				this.searchObj.startDate = this.searchObj.dateArr[0] + ' 00:00:00'
				this.searchObj.endDate = this.searchObj.dateArr[1] + ' 23:59:59'
			} else {
				this.searchObj.startDate = ''
				this.searchObj.endDate = ''
			}
			let params = {
				type: '1001016002',
				sname: this.searchObj.sname,
				abortDate: this.searchObj.abortDate,
				startDate: this.searchObj.startDate,
				endDate: this.searchObj.endDate,
				publisher: this.searchObj.publisher,
				current: this.currentPage,
				size: this.pageSize
			}
			getRules(params)
				.then((res) => {
					this.loading = false
					// console.log(res)
					if (res.code === 0) {
						this.totalResult = parseInt(res.data.total)
						this.tableData = res.data.records
					}
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 点击刷新
		doRefresh() {
			this.$refs.searchForm.resetFields()
			this.searchObj.endDate = ''
			this.pageSize = 10
			this.currentPage = 1
			this.searchObj.dateArr = []
			this.doSearch()
		},

		// 关闭弹窗
		handleClosed() {
			this.ruleForm.id = ''
			this.ruleForm.sname = ''
			this.ruleForm.type = ''
			this.ruleForm.applySys = ''
			this.ruleForm.applySysList = []
			this.ruleForm.applyRole = ''
			this.ruleForm.applyRoleList = []
			this.ruleForm.content = ''
			this.ruleForm.abortDate = ''

			this.doSearch()
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = that.searchObj.endDate
					if (endTime) {
						return bmElementTimeOptins.limitDateBefore(time, endTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.searchObj.startDate
					if (startTime) {
						let nowTime = Date.now()
						// eslint-disable-next-line no-undef
						return bmElementTimeOptins.limitDateInRange(time, startTime, nowTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		}
	},
	computed: {
		...mapState('dict', {
			xyzdlx: (state) => state.projectDict.xyzdlx || []
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		// 制度类型
		rulesList() {
			let arr = [{ sname: '协议制度', value: '', children: [] }]
			this.xyzdlx && this.xyzdlx.length > 0 ? arr[0].children.push(...this.xyzdlx) : ''
			return arr
		},

		// 应用业务
		filterRange() {
			let arr = []
			this.ruleForm.applySysList.map((x) => {
				let _item = this.rangeList.find((y) => y.value === x)
				arr.push(_item)
			})
			return arr
		}
	},
	watch: {
		// 监听范围的变化
		// 'ruleForm.applySysList': {
		// 	handler: function(val) {
		// 		this.ruleForm.applyRoleList = []
		// 	},
		// 	deep: true
		// },
	}
}
</script>

<style scoped lang="less">
.left-pane {
	padding: 10px;
}

.operation-header {
	justify-content: space-between;
	// .title {
	// 	// border-left: none;
	// 	// padding-left: 0;
	// }
}

.input-width {
	min-width: 250px;
}
.vxe-switch.is--disabled {
	opacity: 1;
	/deep/ .vxe-switch--button {
		cursor: pointer !important;
	}
}
/deep/ .is--on {
	.vxe-switch--button {
		background-color: #2671cc !important;
	}
}
.content-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	.title {
		padding-left: 10px;
		border-left: 4px solid #2671cc;
		font-size: 14px;
		color: #202020;
	}
	.blue {
		font-size: 18px;
		color: #2671cc;
	}
}
.pd5 {
	padding: 0 5px;
}
</style>
